import {
  saveOrUpdateSponsorApi,
  querySponsorApi,
  getSponsorByIdApi,
  deleteSponsorByIdApi,
  saveOrUpdateTreasureActivityApi,
  queryTreasureActivityApi,
  getTreasureActivityByIdApi,
  updateTreasureActivityStateApi,
  generateTreasureSecretPwdApi,
  saveOrUpdateTreasureActivityRedApi,
  queryTreasureActivityRedApi,
  getTreasureActivityRedByIdApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  新增/更新赞助商(冠名商)
  async saveOrUpdateSponsorAction(context, param) {
    const res = await saveOrUpdateSponsorApi(param)
    return res
  },
  //  分页查询赞助商
  async querySponsorAction(context, param) {
    const res = await querySponsorApi(param)
    return res
  },
  //  根据赞助商id获取详情
  async getSponsorByIdAction(context, param) {
    const res = await getSponsorByIdApi(param)
    return res
  },
  //  根据赞助商id删除
  async deleteSponsorByIdAction(context, param) {
    const res = await deleteSponsorByIdApi(param)
    return res
  },
  //  新增/更新藏宝活动
  async saveOrUpdateTreasureActivityAction(context, param) {
    const res = await saveOrUpdateTreasureActivityApi(param)
    return res
  },
  //  分页查询藏宝活动
  async queryTreasureActivityAction(context, param) {
    const res = await queryTreasureActivityApi(param)
    return res
  },
  //  根据id获取藏宝活动详情
  async getTreasureActivityByIdAction(context, param) {
    const res = await getTreasureActivityByIdApi(param)
    return res
  },
  //  开启/停止/作废藏宝活动
  async updateTreasureActivityStateAction(context, param) {
    const res = await updateTreasureActivityStateApi(param)
    return res
  },
  //  生成藏宝活动暗号
  async generateTreasureSecretPwdAction(context, param) {
    const res = await generateTreasureSecretPwdApi(param)
    return res
  },
  //  新增/更新红包
  async saveOrUpdateTreasureActivityRedAction(context, param) {
    const res = await saveOrUpdateTreasureActivityRedApi(param)
    return res
  },
  //  分页查询红包
  async queryTreasureActivityRedAction(context, param) {
    const res = await queryTreasureActivityRedApi(param)
    return res
  },
  //  根据id获取红包详情
  async getTreasureActivityRedByIdAction(context, param) {
    const res = await getTreasureActivityRedByIdApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
